import { CardType } from '../../../global-types/card';
import { GetShareEcardLinkOptions } from '../analytics-context-types';
import { getDGModalTag, getPODProductTag } from './utils';

export const getShareEcardLinkTag = (options: GetShareEcardLinkOptions) => {
  const shareEcardLinkEvent = [
    {
      eventInfo: {
        eventName: 'share-ecard-link',
        eventAction: options.eventAction,
      },
    },
  ];

  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType || CardType.DG,
    options.productQuantity,
  );

  const { modal, user } = getDGModalTag('Preview', shareEcardLinkEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
